import { BankHandlerCode, formatBankHandlerCode } from "./bankHandlerCodeFormatter";
import { InvestmentHouseCode, formatInvestmentHouseCode } from "./investmentHouseCodeFormatter";
import { formatHandlerCode } from "./namesFormater";
import { RealEstateType } from "./manualProductTypeFormatter";

export const formatRealEstateType = (code: string): string => {
  switch (code) {
    case RealEstateType.RESIDENTIAL: return "מגורים";
    case RealEstateType.INVESTMENT: return 'נדל"ן להשקעה';
    case RealEstateType.ABROAD: return 'נדל"ן בחו"ל';
    default: return code;
  }
};

/**
 * פורמטר אוניברסלי לקוד יצרן (handler_code)
 * מנסה את כל ה-enums הידועים עד שמוצא התאמה
 * אם לא מוצא - מחזיר את הערך המקורי
 */
export const formatHandlerCodeUniversal = (code: string): string => {
  if (!code) return "";

  // ניסיון 1: סוגי נדל"ן
  if (Object.values(RealEstateType).includes(code as RealEstateType)) {
    return formatRealEstateType(code);
  }

  // ניסיון 2: בנקים
  if (Object.values(BankHandlerCode).includes(code as BankHandlerCode)) {
    return formatBankHandlerCode(code as BankHandlerCode);
  }

  // ניסיון 2: בתי השקעות
  if (Object.values(InvestmentHouseCode).includes(code as InvestmentHouseCode)) {
    return formatInvestmentHouseCode(code as InvestmentHouseCode);
  }

  // ניסיון 3: חברות ביטוח/יצרנים פיננסיים
  const formattedHandler = formatHandlerCode(code);
  if (formattedHandler && formattedHandler !== code) {
    return formattedHandler;
  }

  // אם לא מצאנו התאמה - מחזיר את הקוד המקורי
  return code;
};
